import { render, staticRenderFns } from "./SerieCharactersSlider.vue?vue&type=template&id=65a7b2d0&"
import script from "./SerieCharactersSlider.vue?vue&type=script&lang=js&"
export * from "./SerieCharactersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports